import HeaderTitle from "src/commonStyles/text/headerTitle/headerTitle";
import StepsPayment from "src/components/homePage/components/steps/steps";
import useCheckMobile from "src/hook/useCheckMobile";
import Step2 from "./step2";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import _, { isEmpty } from "lodash";
import React from "react";
import { QueryInquiryBill } from "src/api/queryInquiryBill";
import { messageQueryError } from "src/const/message";
import PopupService from "src/utils/PopupService";
import { useCheckLoading } from "src/providers/checkLoadingProvider";
import { getDataInquiryFromAnotherPlatfom } from "src/api/inquiryRequestItem";
import { AxiosError } from "axios";
import { CALLBACK_URL } from "src/const/const-from-env";

interface IParams {
  frSystm: string;
  idNumber: string;
  phDoB: string;
  laDoB: string;
}

interface IParamsUrl {
  requestId?: string;
}

const InfoPay = () => {
  const params: IParamsUrl = Object.fromEntries(
    new URLSearchParams(location.search.split("?")[1])
  );
  const { state } = useLocation();
  const stateV2 = state as { data: any; frSystm?: string };

  const isMobile = useCheckMobile();
  const [dataToSend, setDataToSend] = React.useState<any>();
  const [frSystemToSend, setFrSystemToSend] = React.useState<any>(
    stateV2?.frSystm
  );
  const [callbackUrl, setCallBackUrl] = React.useState(CALLBACK_URL)
  const { setIsLoading } = useCheckLoading();
  const [messageQueryText, setMessageQueryText] = React.useState("");

  const navigate = useNavigate();
  const onPressStep = (step: any) => {
    // setStep(step);
  };

  useEffect(() => {
    localStorage.removeItem("paymentResult");
    localStorage.removeItem("dataInfoPay");
    if (state === null && _.isEmpty(state) && !params?.requestId) {
      navigate("/");
    } else if (params?.requestId) {
      callGetDataFromAnotherPlatform();
    } else {
      setDataToSend(stateV2?.data);
    }
  }, []);

  const callGetDataFromAnotherPlatform = async () => {
    setIsLoading(true);
    try {
      const res = await getDataInquiryFromAnotherPlatfom(params?.requestId);
      const data = res?.data?.data;
      setDataToSend(res?.data.data.result.data);
      setCallBackUrl(data?.callbackURL)
      setFrSystemToSend(data?.frSystm);
    } catch (e) {
      const err = e as AxiosError;
      PopupService.instance.current.open({
        visible: true,
        content: getErrorMessage(e),
        onOk: () => {
          PopupService.instance.current.close();
          navigate("/");
        },
      });
    } finally {
      setIsLoading(false);
    }
  };
  function getErrorMessage(error: unknown): string {
        const defaultMsg = "Đã có lỗi xảy ra";
        if (!error || typeof error !== "object") return defaultMsg;

        const axiosErr = error as AxiosError & { response?: any; message?: any };
        const data = axiosErr.response?.data;

        const msg =
            data?.msgSts?.message ??
            data?.message ??
            axiosErr.message ??
            defaultMsg;

        return String(msg);
    }

  useEffect(() => {
    if (dataToSend) {
      localStorage.setItem('dataInfoPay', JSON.stringify(dataToSend));
    }
  },[dataToSend])

  return (
    <div>
      {!isMobile && <HeaderTitle>Đóng phí bảo hiểm</HeaderTitle>}
      <StepsPayment step={1} onPressStep={onPressStep} />
      <div>
        {!isEmpty(dataToSend) && (
          <Step2 data={dataToSend} frSystm={frSystemToSend} callbackUrl={callbackUrl}/>
        )}
      </div>
    </div>
  );
};

export default InfoPay;
